// Search stays in browser memory; credentials are never persisted or sent to an API.
export function matchesProxySearch(proxy, input) {
  let query = String(input ?? '').trim();
  if (!query) return true;
  query = query.replace(/^(?:https?|socks5h?):\/\//i, '');
  const ports = [proxy.http_port, proxy.socket_port]
    .filter(value => value !== null && value !== undefined && value !== '')
    .map(String);
  // Preserve the original partial-port search.
  if (/^\d+$/.test(query)) return ports.some(port => port.includes(query));
  const rawHost = String(proxy.host_domain ?? '').trim();
  if (!rawHost) return false;
  const host = rawHost.replace(/^\[|\]$/g, '');
  const hosts = host.includes(':') ? [host, `[${host}]`] : [host];
  const lower = query.toLowerCase();
  if (hosts.some(value => value.toLowerCase() === lower)) return true;
  const auth = String(proxy.authentication_user ?? '');
  return hosts.some(value => ports.some(port => {
    const endpoint = `${value}:${port}`.toLowerCase();
    if (lower === endpoint) return true;
    if (!auth) return false;
    const prefix = `${endpoint}:`;
    const suffix = `@${endpoint}`;
    // Hostnames are case-insensitive; credentials must match exactly.
    return (lower.startsWith(prefix) && query.slice(prefix.length) === auth)
      || (lower.endsWith(suffix) && query.slice(0, -suffix.length) === auth);
  }));
}
